import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import FeatureGrid from "./components/FeatureGrid";
import ComparisonTable from "./components/ComparisonTable";
import EditorialSection from "./components/EditorialSection";
import ReviewsSection from "./components/ReviewsSection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const SITE_URL = "https://hipobuyspread.cfd";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "Hipobuy Spreadsheet",
      url: SITE_URL,
      description:
        "The ultimate resource hub for Hipobuy Spreadsheet guides, product research tools, comparisons, and expert shopping tips.",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: "Hipobuy Spreadsheet",
      url: SITE_URL,
      description:
        "Independent educational resource providing comprehensive Hipobuy Spreadsheet guides, product research comparisons, and shopping safety information.",
      sameAs: ["https://kaspreadsheet.com"],
    },
  ],
};

export default function Home() {
  return (
    <main>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <CTASection />
      <FeatureGrid />
      <ComparisonTable />
      <EditorialSection />
      <ReviewsSection />
      <Footer />
    </main>
  );
}